import { Container } from "../Container/Container";
import { NavigationHeader } from "../Navigation/NavigationHeader";

export const Header = () => {
  return (
    <header>
      <Container>
        <div className="flex justify-center py-4">
          <NavigationHeader />
        </div>
      </Container>
    </header>
  );
};
